import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Provider } from 'react-redux';
import store from './model/store';
import reportWebVitals from './reportWebVitals';
import ThemeWrapper from './ThemeWrapper';

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <ThemeWrapper />
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
